import chain from '@/lib/axios-chain'

// 规则列表
export const getRecycleList = () => chain.create('/inquiry/recycle/list', 'get')

// 获取规则详情以及规则配置
export const getRuleCondition = () => chain.create('/inquiry/recycle/getRuleCondition', 'get')

// 添加回收规则
export const addRecycle = () => chain.create('/inquiry/recycle/add', 'post')

// 删除
export const delRecycle = () => chain.create('/inquiry/recycle/del', 'post')

// 询盘规则实时提示
export const getRecycleRuleTips = () => chain.create('/inquiry/recycle/ruleTips', 'post')

// 获取询盘规则重置后的提示说明
export const getRecycleLogTip = () => chain.create('/inquiry/recycle/getRecycleLogTip', 'get')
